import { FailureCodeEnum as InvoiceDisputedFailureCode } from 'anchor-ts-infra/src/dto/invoice';
import { Accounting } from './accounting';
export var DraftCreationSource = /*#__PURE__*/ function(DraftCreationSource) {
    DraftCreationSource["Direct"] = "direct";
    DraftCreationSource["Bulk"] = "bulk";
    DraftCreationSource["Unknown"] = "unknown";
    return DraftCreationSource;
}({});
export var BillingScheduleDisplay = /*#__PURE__*/ function(BillingScheduleDisplay) {
    BillingScheduleDisplay["Timeline"] = "timeline";
    BillingScheduleDisplay["ByBillingOccurrence"] = "byBillingOccurrence";
    return BillingScheduleDisplay;
}({});
export var NotificationsFullControlOverride = /*#__PURE__*/ function(NotificationsFullControlOverride) {
    NotificationsFullControlOverride["Enabled"] = "enabled";
    NotificationsFullControlOverride["Disabled"] = "disabled";
    return NotificationsFullControlOverride;
}({});
export var SigningPolicyType = /*#__PURE__*/ function(SigningPolicyType) {
    SigningPolicyType["AllSigners"] = "allSigners";
    SigningPolicyType["AnySigner"] = "anySigner";
    return SigningPolicyType;
}({});
export var RepublishChangeType = /*#__PURE__*/ function(RepublishChangeType) {
    RepublishChangeType["Services"] = "services";
    RepublishChangeType["Packages"] = "packages";
    RepublishChangeType["TermsOfService"] = "termsOfService";
    RepublishChangeType["CustomPages"] = "customPages";
    RepublishChangeType["PaymentTerms"] = "paymentTerms";
    RepublishChangeType["EffectiveDate"] = "effectiveDate";
    RepublishChangeType["BillingSchedule"] = "billingSchedule";
    RepublishChangeType["SalesTax"] = "salesTax";
    RepublishChangeType["PaymentFees"] = "paymentFees";
    RepublishChangeType["PaymentAndApprovalSettings"] = "paymentAndApprovalSettings";
    RepublishChangeType["Title"] = "title";
    RepublishChangeType["AgreementNote"] = "agreementNote";
    return RepublishChangeType;
}({});
export var TaxedAgreements = /*#__PURE__*/ function(TaxedAgreements) {
    TaxedAgreements["None"] = "none";
    TaxedAgreements["One"] = "one";
    TaxedAgreements["Many"] = "many";
    return TaxedAgreements;
}({});
export var SignatureFieldType = /*#__PURE__*/ function(SignatureFieldType) {
    SignatureFieldType["Signature"] = "signature";
    SignatureFieldType["Initials"] = "initials";
    SignatureFieldType["Text"] = "text";
    SignatureFieldType["Date"] = "date";
    SignatureFieldType["DateNow"] = "datenow";
    SignatureFieldType["Checkbox"] = "checkbox";
    return SignatureFieldType;
}({});
export var BillingTriggerType = /*#__PURE__*/ function(BillingTriggerType) {
    /** Billed once, automatically, on client's approval of service/agreement. */ BillingTriggerType["OnApproval"] = "approval";
    /** Automatic, scheduled, recurring billing. */ BillingTriggerType["Ongoing"] = "ongoing";
    /** Billed once, manually, by the vendor. */ BillingTriggerType["OneTimeManual"] = "oneTimeManual";
    /** Manual recurring billing. Vendor is allowed to manually bill the client once. */ BillingTriggerType["RepeatableManual"] = "repeatableManual";
    BillingTriggerType["OneTimeInStages"] = "oneTimeInStages";
    BillingTriggerType["OnDemand"] = "onDemand";
    return BillingTriggerType;
}({});
export var PlaidAccountType = /*#__PURE__*/ function(PlaidAccountType) {
    PlaidAccountType["Depository"] = "depository";
    PlaidAccountType["Credit"] = "credit";
    PlaidAccountType["Loan"] = "loan";
    PlaidAccountType["Investment"] = "investment";
    PlaidAccountType["Other"] = "other";
    return PlaidAccountType;
}({});
export var PlaidDepositoryAccountSubtype = /*#__PURE__*/ function(PlaidDepositoryAccountSubtype) {
    PlaidDepositoryAccountSubtype["Checking"] = "checking";
    PlaidDepositoryAccountSubtype["Savings"] = "savings";
    PlaidDepositoryAccountSubtype["HSA"] = "hsa";
    PlaidDepositoryAccountSubtype["CD"] = "cd";
    PlaidDepositoryAccountSubtype["MoneyMarket"] = "money market";
    PlaidDepositoryAccountSubtype["Paypal"] = "paypal";
    PlaidDepositoryAccountSubtype["Prepaid"] = "prepaid";
    PlaidDepositoryAccountSubtype["CashManagement"] = "cash management";
    PlaidDepositoryAccountSubtype["EBT"] = "ebt";
    return PlaidDepositoryAccountSubtype;
}({});
export var FeatureAccessPurpose = /*#__PURE__*/ function(FeatureAccessPurpose) {
    FeatureAccessPurpose["TaxSeasonEngagements"] = "taxSeasonEngagements";
    FeatureAccessPurpose["OnboardingNewClients"] = "onboardingNewClients";
    FeatureAccessPurpose["RenewingClientAgreements"] = "renewingClientAgreements";
    FeatureAccessPurpose["UpdatingClientPricing"] = "updatingClientPricing";
    FeatureAccessPurpose["Other"] = "other";
    return FeatureAccessPurpose;
}({});
export var StartBillingOnEnum = /*#__PURE__*/ function(StartBillingOnEnum) {
    StartBillingOnEnum["SkipBillingOnAcceptance"] = "skipBillingOnAcceptance";
    StartBillingOnEnum["Earliest"] = "earliest";
    StartBillingOnEnum["StartPaused"] = "startPaused";
    return StartBillingOnEnum;
}({});
export const INVOICE_DASHBOARD_CARD_IDS = [
    'collection-rate',
    'anchor-vs-external',
    'avg-days-to-pay',
    'outstanding',
    'aging-breakdown',
    'avg-invoice',
    'paid',
    'pending',
    'overdue',
    'issued',
    'processing',
    'refunded',
    'voided',
    'disputed',
    'missing-payment-method',
    'client-approval-required',
    'payment-stopped',
    'payment-failed',
    'payment-validation-required',
    'payment-method-unverified'
];
export const DEFAULT_INVOICE_DASHBOARD_CARDS = [
    'collection-rate',
    'anchor-vs-external',
    'avg-days-to-pay',
    'outstanding',
    'aging-breakdown'
];
export var InvoicePaymentMethodStatus = /*#__PURE__*/ function(InvoicePaymentMethodStatus) {
    InvoicePaymentMethodStatus["PaymentMethodSet"] = "paymentMethodSet";
    InvoicePaymentMethodStatus["PaymentMethodNotSet"] = "paymentMethodNotSet";
    InvoicePaymentMethodStatus["PaymentMethodUnverified"] = "paymentMethodUnverified";
    return InvoicePaymentMethodStatus;
}({});
export var LineItemPendingApprovalReason = /*#__PURE__*/ function(LineItemPendingApprovalReason) {
    LineItemPendingApprovalReason["AdHocCharge"] = "ad-hoc-charge";
    LineItemPendingApprovalReason["ServiceAmendment"] = "service-amendment";
    LineItemPendingApprovalReason["VariableExceedsCap"] = "variable-exceeds-cap";
    LineItemPendingApprovalReason["VariableZeroCap"] = "variable-zero-cap";
    LineItemPendingApprovalReason["RangeExceedsMaxPrice"] = "range-exceeds-max-price";
    LineItemPendingApprovalReason["VariableCumulative"] = "variable-cumulative";
    LineItemPendingApprovalReason["NonVariableCumulative"] = "non-variable-cumulative";
    LineItemPendingApprovalReason["OverlappingPeriod"] = "overlapping-period";
    return LineItemPendingApprovalReason;
}({});
export { InvoiceDisputedFailureCode };
export var IntegrationStatus = /*#__PURE__*/ function(IntegrationStatus) {
    IntegrationStatus["Error"] = "error";
    IntegrationStatus["Linked"] = "linked";
    IntegrationStatus["Unlinked"] = "unlinked";
    return IntegrationStatus;
}({});
export var PracticeManagement = /*#__PURE__*/ function(PracticeManagement) {
    PracticeManagement["Keeper"] = "keeper";
    PracticeManagement["Karbon"] = "karbon";
    PracticeManagement["ClientHub"] = "client-hub";
    PracticeManagement["FinancialCents"] = "financial-cents";
    return PracticeManagement;
}({});
export var TaxWorkflow = /*#__PURE__*/ function(TaxWorkflow) {
    TaxWorkflow["StanfordTax"] = "stanford-tax";
    return TaxWorkflow;
}({});
export var IntegrationResponseStatus = /*#__PURE__*/ function(IntegrationResponseStatus) {
    IntegrationResponseStatus["Success"] = "success";
    IntegrationResponseStatus["Error"] = "error";
    return IntegrationResponseStatus;
}({});
export const isPracticeManagementIntegrationItem = (value)=>value.id !== undefined;
export const isAccountingQbo = (accounting)=>accounting === Accounting.QBO;
export const isAccountingXero = (accounting)=>accounting === Accounting.Xero;
